import { lifeCycleEventName } from '../constant/lifeCycleEventName';
import { AutoDetectedErrorType, SeverityType, StaticFileType } from '../constant';
import { AirTrackerPlugin } from '../interface/plugins';
import { safeStringify } from '../util/jsonHelper';
export const errorDetectionPlugin = new AirTrackerPlugin({
    name: 'errorDetectionPlugin',
    setUp: (airTracker) => {
        // 1. capture window.onerror event
        const orgError = window.onerror;
        // ...args  = [event, source, lineno, colno, error]
        // refer to https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
        window.onerror = (...args) => {
            const errString = `${safeStringify(args[0]) || ''} @ (${safeStringify(args[1]) || ''}:${args[2] || 0}:${args[3] || 0})\n${safeStringify(args[4] || '')}`;
            airTracker.normalLogPipeLine({
                severity: SeverityType.AUTO_DETECT_ERROR,
                eventName: AutoDetectedErrorType.windowOnError,
                error: errString,
            });
            orgError === null || orgError === void 0 ? void 0 : orgError.call(window, ...args);
        };
        // 2. capture unhandledrejection
        const unhandledrejectionHandler = (event) => {
            const reason = event && safeStringify(event.reason);
            airTracker.normalLogPipeLine({
                severity: SeverityType.AUTO_DETECT_ERROR,
                eventName: AutoDetectedErrorType.promiseError,
                error: reason,
            });
        };
        window.addEventListener('unhandledrejection', unhandledrejectionHandler);
        // 3. capture static file load error （listen on window.documents error events）
        const errorHandler = (event) => {
            // get the target of the event
            // under this context, the taget is an element (as we only wonder capture static file load error)
            const target = (event === null || event === void 0 ? void 0 : event.target) || (event === null || event === void 0 ? void 0 : event.srcElement);
            if (!target) {
                return;
            }
            const url = (target === null || target === void 0 ? void 0 : target.src) || (target === null || target === void 0 ? void 0 : target.href);
            const { tagName } = target;
            let staticFileType = StaticFileType.unknown;
            if (typeof url === 'string' && tagName) {
                if (window.location.href.indexOf(url) > -1) {
                    // if src is empty, src will turn to be location.href(without hash)
                    // this kind of error will be ignored
                    // refer to this answer for detail (https://stackoverflow.com/questions/57053650/if-i-add-a-blank-script-src-script-to-my-page-what-would-happen)
                    // some empty src use case: (https://sitechecker.pro/site-audit-issues/page-empty-src-attributes/)
                    return;
                }
                // first test based on suffix
                if (/\.js$/.test(url)) {
                    staticFileType = StaticFileType.script;
                }
                else if (/\.css$/.test(url)) {
                    staticFileType = StaticFileType.css;
                }
                else {
                    // then test base on tagName
                    switch (tagName.toLowerCase()) {
                        case 'script':
                            staticFileType = StaticFileType.script;
                            break;
                        case 'link':
                            staticFileType = StaticFileType.css;
                            break;
                        case 'img':
                            staticFileType = StaticFileType.img;
                            break;
                        case 'audio':
                        case 'video':
                            staticFileType = StaticFileType.media;
                            break;
                        default:
                            return;
                    }
                }
                airTracker.normalLogPipeLine({
                    severity: SeverityType.AUTO_DETECT_ERROR,
                    eventName: AutoDetectedErrorType.staticFileLoadError,
                    staticFileType,
                    error: `${tagName} load fail: ${url}`,
                });
            }
        };
        window.document.addEventListener('error', errorHandler, true);
        airTracker.lifeCycle.on(lifeCycleEventName.onDestroy, () => {
            window.removeEventListener('unhandledrejection', unhandledrejectionHandler);
            window.document.removeEventListener('error', errorHandler, true);
        });
    },
});
